import { Action } from '@ngrx/store/src/models';

import { StorageChangeAction, StorageChangeActionType } from './storage.types';

const NGRX_STORAGE_KEY = 'WO';

export const createStorageKeySerializer = (name: string) => (key: string) =>
  `${NGRX_STORAGE_KEY} ${ name } => ${ key }`;

export const createStorageKeyDeserializer = (name: string) => (key: string) =>
  key.match(`${ NGRX_STORAGE_KEY } ${ name } => (.*)`)?.[1];

export const isStorageChangeAction = (action: Action): action is StorageChangeAction => action.type === StorageChangeActionType;

export const isAnyStorageKey = (key: string): boolean =>
  Boolean(key.match(`${ NGRX_STORAGE_KEY } (.*) => (.*)`)?.[1]);

export const isStorageKey = (key: string, name: string): boolean =>
  Boolean(key.match(`${ NGRX_STORAGE_KEY } ${ name } => (.*)`)?.[1]);
